import { useEffect, useMemo, useState, useRef } from 'react'
import { Container } from '@cleartrip/ct-design-components'

import HomeMain from '@/components/home/HomeMain'
import { UnifiedWidgetStackProvider } from '@/components/home/UnifiedWidgetStack'
import Footer from '@/components/common/Footer/index'
import { triggerRavenHomePageload } from '@/analytics/raven/ravenUtils'
import FooterMock from '@/mocks/footer.json'

import { getActionPayload } from '@/utils/general/actions'
import { storeUtmParams } from '@/utils/general'
import { ActionMapper } from '@/types'
import { useAppDispatch } from '@/redux/store/hooks'
import { isUserSignedIn } from '@/utils/general/user'
import { BbdJson } from '@/types/home'
import HomeHeaderV2 from '@/components/home/HomeHeaderV2'
import InlineSectionErrorFallback from '@/components/shared/InlineSectionErrorFallback'
import { withErrorBoundary } from '@/components/shared/SentryErrorBoundary'
import { registerUserToCollection } from '@/api/homepage'
import { getCollectionRegisterationInfo } from '@/utils/apiHelper/common'

const HomeContainer: React.FC<{ isSignedIn: boolean , uhpCookie : boolean | string,data: BbdJson[]}> = ({ isSignedIn , uhpCookie,data}) => {
    const globalDispatcher = useAppDispatch()
    const [supercoinAndLoyaltyData, setSupercoinAndLoyaltyData] = useState({
        supercoinbalance: 0,
        loyalty: '',
        isSupercoinAPICalled: false
    })
    const hasTriggeredRavenLoad = useRef(false)

    useEffect(() => {
        storeUtmParams()
        const { registerUser, utmCustom } = getCollectionRegisterationInfo()
        if (registerUser) {
          registerUserToCollection({ utmPaid: utmCustom })
        }
        try {
            if (!isUserSignedIn()) {
                const obj = JSON.parse(window?.sessionStorage.getItem('loginPopup') || '{}')
                if (!obj?.flightHome) {
                    window.sessionStorage.setItem(
                        'loginPopup',
                        JSON.stringify({
                            ...obj,
                            flightHome: 'true',
                            flightIternary: 'true',
                            hotelIternary: 'true',
                            hotelHome: 'true'
                        })
                    )
                    globalDispatcher(getActionPayload('OPEN_MODAL', { type: ActionMapper.OPEN_LOG_IN_MODAL }))
                }
            }
        } catch (err) {
            console.log(err)
        }
    }, [])

    useEffect(() => {
      if (isUserSignedIn()) {
        if (supercoinAndLoyaltyData?.isSupercoinAPICalled && !hasTriggeredRavenLoad.current) {
          triggerRavenHomePageload()
          hasTriggeredRavenLoad.current = true
        }
      } else {
        if (!hasTriggeredRavenLoad.current) {
          triggerRavenHomePageload()
          hasTriggeredRavenLoad.current = true
        }
      }
    }, [supercoinAndLoyaltyData?.isSupercoinAPICalled, isSignedIn])

    const unifiedConfig = useMemo(
        () => ({ widgets: { cysWidget: isSignedIn, loyaltyWidget: true } }),
        [isSignedIn]
    )

    return (
        <Container>
            <HomeHeaderV2 isSignedIn={isSignedIn} supercoinAndLoyaltyData={supercoinAndLoyaltyData} setSupercoinAndLoyaltyData={setSupercoinAndLoyaltyData}/>
            <main>
                <UnifiedWidgetStackProvider config={unifiedConfig} isSignedIn={isSignedIn}>
                    <HomeMain uhpCookie={uhpCookie} data={data}/>
                </UnifiedWidgetStackProvider>
            </main>
            {/* @ts-ignore */}
            <Footer data={{ data: FooterMock.slotData.data }} />
        </Container>
    )
}
export default withErrorBoundary(HomeContainer, {
    boundary: 'home-container',
    page: 'home',
    isPageLevel: true,
    fallbackRender: ({ resetErrorBoundary }) => (
        <InlineSectionErrorFallback
            title="Home container couldn't load"
            onRetry={resetErrorBoundary}
        />
    )
})
